var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6825 16.1908H35.7945L30.6254 11.0185C28.9612 9.35425 26.8882 8.15747 24.6149 7.54844C22.3415 6.93941 19.9479 6.93959 17.6746 7.54895C15.4013 8.15832 13.3285 9.35541 11.6646 11.0199C10.0006 12.6843 8.80418 14.7575 8.19552 17.031M6.49577 32.9218V24.8098M6.49577 24.8098H14.6078M6.49577 24.8098L11.6633 29.9822C13.3275 31.6464 15.4004 32.8432 17.6738 33.4522C19.9472 34.0613 22.3408 34.0611 24.6141 33.4517C26.8874 32.8423 28.9602 31.6453 30.6241 29.9808C32.288 28.3163 33.4845 26.2432 34.0931 23.9697M35.7945 8.07883V16.1876",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.d0bf4def39dfdbf5a90bd6c2a9ba6a53.svg";
export { ForwardRef as ReactComponent };